export default function HeroSection() {
  return (
    <section id="hero" className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20lifestyle%20collage%20of%20fashion%20shopping%20essentials%20on%20a%20white%20marble%20surface%2C%20sneakers%20alongside%20a%20tablet%20displaying%20colorful%20spreadsheet%20data%2C%20green%20plant%20accent%2C%20soft%20morning%20sunlight%20streaming%20through%20window%20blinds%20creating%20striped%20shadows%2C%20editorial%20photography%20with%20high%20contrast%20and%20sharp%20detail%2C%20modern%20aesthetic%20with%20pops%20of%20warm%20terracotta%20and%20sage%20green%20tones&width=1800&height=1000&seq=hero-bg-v3&orientation=landscape"
          alt="VigorBuy Spreadsheet - Fashion product collection on marble desk"
          className="w-full h-full object-cover object-top"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/25 to-black/40"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-12 lg:gap-20">
          {/* Left Content */}
          <div className="flex-1 text-center lg:text-left pt-20 md:pt-24">
            <p className="text-background-50/90 text-xs md:text-sm font-semibold uppercase tracking-widest mb-4">
              Updated Weekly &bull; 5000+ Products
            </p>
            <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight">
              The Best<br />
              <span className="text-accent-300">VigorBuy Spreadsheet</span><br />
              in 2026
            </h1>
            <p className="mt-5 text-background-50/85 text-sm md:text-base max-w-lg mx-auto lg:mx-0 leading-relaxed">
              Find trusted sellers, QC guides, shipping tips and updated spreadsheet links. The most complete resource for smart shoppers worldwide.
            </p>
            <div className="flex flex-col sm:flex-row items-center gap-3 mt-8 justify-center lg:justify-start">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="w-full sm:w-auto px-8 py-3.5 bg-accent-500 text-background-50 font-bold text-sm rounded-full hover:bg-accent-600 transition-all duration-200 text-center whitespace-nowrap cursor-pointer shadow-lg"
              >
                Explore Spreadsheet
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="w-full sm:w-auto px-8 py-3.5 border-2 border-background-50/60 text-background-50 font-bold text-sm rounded-full hover:bg-background-50 hover:text-foreground-950 transition-all duration-200 text-center whitespace-nowrap cursor-pointer"
              >
                View Seller Lists
              </a>
            </div>

            {/* Stats */}
            <div className="flex flex-wrap items-center gap-6 md:gap-10 mt-10 justify-center lg:justify-start">
              <div className="text-center">
                <p className="text-2xl md:text-3xl font-bold text-background-50 font-heading">5,000+</p>
                <p className="text-xs text-background-50/70 mt-1 font-medium">Products</p>
              </div>
              <div className="w-px h-8 bg-background-50/20 hidden sm:block"></div>
              <div className="text-center">
                <p className="text-2xl md:text-3xl font-bold text-background-50 font-heading">300+</p>
                <p className="text-xs text-background-50/70 mt-1 font-medium">Sellers</p>
              </div>
              <div className="w-px h-8 bg-background-50/20 hidden sm:block"></div>
              <div className="text-center">
                <p className="text-2xl md:text-3xl font-bold text-background-50 font-heading">Weekly</p>
                <p className="text-xs text-background-50/70 mt-1 font-medium">Updated</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}